<!-- PROCESO MANUAL -->
@if (!operation?.config?.iframe) {
    <tec-pwcs-layout
        [ngClass]="{
            dark: designService.isDarkMode(),
            'hide-subtitle': !(operation?.config.tutorial || pageWarning.show || handsetLandscape),
            'take-photo': !manualLifeCheckConf?.general?.photo
        }"
        [title]="pageWarning.type === PAGE_WARNING.HELP ? ('LIFE_CHECK.HELP.TITLE' | translate) : ''"
        [subtitle]="subtitle"
        [footerLabel]="
            operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape
                ? ('GENERAL.TUTORIAL_ENCRYPTION' | translate)
                : ''
        "
    >
        <!-- PROGRESS -->
        <tec-progress [value]="progressService.getValue()"></tec-progress>

        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && permissionsCamera && !handsetLandscape) {
            <tec-alert
                [msg]="'LIFE_CHECK.TUTORIAL_TIP' | translate"
                type="message"
                status="success"
                hiddenCloseButton
            ></tec-alert>
        }

        <!-- CONTENT -->
        <ng-container content [ngTemplateOutlet]="fullContent"> </ng-container>

        <!-- ACTIONS -->
        <ng-container actions [ngTemplateOutlet]="fullActions"> </ng-container>

        <!-- NAV HELP -->
        @if (permissionsCamera && !pageWarning.show && !handsetLandscape) {
            <tec-nav-help
                [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
                (clickEvent)="navHelpChange($event)"
            ></tec-nav-help>
        }

        <!-- WATERMARK -->
        @if ((designService.configDesign$ | async)?.showWatermark) {
            <tec-watermark type="default"></tec-watermark>
        }
    </tec-pwcs-layout>
}

<ng-template #face>
    <!-- MAIN -->
    <div
        class="content__identity"
        [ngStyle]="{
            display: operation?.config.tutorial || pageWarning.show || handsetLandscape ? 'none' : 'contents'
        }"
    >
        @if (loading.show) {
            <tec-spinner
                [show]="loading.show"
                [opaque]="true"
                [text]="loading.text"
                [img]="designService.getCustomSpinnerUrl() || undefined"
            ></tec-spinner>
        }
        <tec-scan-face [hidden]="loading.show || manualLifeCheckConf.general.photo" [match]="true" [grow]="true">
            <app-video
                [fillParent]="true"
                [constraints]="lifeCheckService.constraints"
                [zoomFactor]="polStaticPreviewZoomFactor"
                [zoomTransformOrigin]="'center center'"
                [enableTapToFocus]="!manualLifeCheckConf?.general?.photo && !loading.show"
                (cameraError)="onCameraError($event)"
                (cameraPermissionRevoked)="onCameraPermissionRevoked()"
                (cameraStarted)="onCameraStarted($event)"
                (cameraSwitchStarted)="onCameraSwitchStarted()"
                (cameraSwitchCompleted)="onCameraSwitchCompleted()"
            ></app-video>
        </tec-scan-face>

        @if (!loading.show) {
            <span class="content__identity__subtitle-mobile" [innerHTML]="subtitle"></span>
        }

        <!-- <div class="tec-alert--float">
    <tec-alert
      *ngIf="!loading.show && alertContent.label && alertContent.status"
      hiddenCloseButton
      type="message"
      [status]="alertContent.status"
      [msg]="alertContent.label"
      [icon]="alertContent.icon"
    ></tec-alert>
  </div> -->

        <!-- BOTON CAMBIO CAMARA -->
        @if (operation?.config?.iframe && allCameras && allCameras.length > 1) {
            <div class="change-camera">
                <span>{{ 'GENERAL.BUTTON.CHANGE_CAMERA' | translate }}</span>
                <tec-button-icon
                    icon="icon-refresh"
                    type="circle"
                    size="lg"
                    (clickEvent)="changeCamera()"
                ></tec-button-icon>
            </div>
        }

        <!-- Imágenes auxiliares -->
        <div [ngStyle]="{ display: manualLifeCheckConf?.general?.photo ? 'inherit' : 'none' }">
            <img id="uploadImage" class="captured-image"/>
        </div>
    </div>
</ng-template>

<ng-template #fullContent>
    <!-- SIN PERMISOS -->
    @if (!permissionsCamera) {
        <tec-tile
            type="status"
            [title]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_TITLE' | translate"
            [subtitle]="'GENERAL.ERROR.NO_PERMISSION_CAMERA_DESCRIPTION' | translate"
            icon="icon-alert"
        >
            <tec-link
                [label]="'LIFE_CHECK.HELP.TITLE' | translate"
                (click)="isVisibleHelpNoPermissionsCamera = true"
            ></tec-link>
        </tec-tile>
    }

    <!-- CON PERMISOS -->
    @if (permissionsCamera) {
        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
            <div class="tutorial-image">
                <div class="pwcs-lottie-frame">
                    <ng-lottie
                        [options]="
                            tutorialLottieOptions || {
                                path: designService.isDarkMode()
                                    ? 'assets/animations/pwcs-prueba-vida-dark.json'
                                    : 'assets/animations/pwcs-prueba-vida-light.json'
                            }
                        "
                    ></ng-lottie>
                </div>
                <!-- <img [src]="designService.isDarkMode() ? 'assets/images/tuto-lifecheck-dark.svg' : 'assets/images/tuto-lifecheck.svg'"> -->
            </div>
        }

        <!-- FACE -->
        <ng-container [ngTemplateOutlet]="face"> </ng-container>

        <!-- HELP -->
        @if (pageWarning.show) {
            @if (pageWarning.type === PAGE_WARNING.HELP) {
                <div class="tile tile--help">
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-blur' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                            idSuffix="manual-life-check-help-kyc-blur"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_1' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                            idSuffix="manual-life-check-help-kyc-bright"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_2' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                            idSuffix="manual-life-check-help-kyc-cut"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_3' | translate }}</span>
                        </p>
                    </div>
                    <div class="image-group">
                        <pwcs-inline-svg
                            [src]="'assets/images/kyc-glasses' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                            idSuffix="manual-life-check-help-kyc-glasses"
                        />
                        <p>
                            <span>{{ 'LIFE_CHECK.MODAL_HELP.TIP_4' | translate }}</span>
                        </p>
                    </div>
                </div>
                <tec-alert
                    [msg]="'OCR.BACK.MODAL_HELP.TIP_5' | translate"
                    type="message"
                    hiddenCloseButton
                    icon="icon-info"
                ></tec-alert>
            }
            @if (pageWarning.type === PAGE_WARNING.NO_FACE) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.NO_FACE.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.MULTIPLE_FACES) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.MULTIPLE_FACES.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.VERIFICATION_FAIL) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.VERIFICATION_FAIL.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.SERVER_ERROR.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.CAMERA_ERROR) {
                <tec-tile
                    type="status"
                    [title]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.TITLE' | translate"
                    [subtitle]="'LIFE_CHECK.PAGE_WARNING.CAMERA_ERROR.DESCRIPTION' | translate"
                    icon="icon-alert"
                ></tec-tile>
            }
            @if (pageWarning.type === PAGE_WARNING.BACK_TO_OCR) {
                <tec-tile
                    type="status"
                    [title]="backToOcrTitleKey | translate"
                    [subtitle]="backToOcrShowSubtitle ? ('LIFE_CHECK.PAGE_WARNING.BACK_TO_OCR.DESCRIPTION' | translate) : ''"
                    icon="icon-alert">
                    <tec-tile>
                        <div class="grid grid-e3-sm">
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-bright' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                    idSuffix="manual-life-check-back-ocr-id-bright"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_2' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-cut' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                    idSuffix="manual-life-check-back-ocr-id-cut"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_3' | translate }}</span>
                            </div>
                            <div class="image-group">
                                <pwcs-inline-svg
                                    [src]="'assets/images/id-finger' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                                    idSuffix="manual-life-check-back-ocr-id-finger"
                                />
                                <span>{{ 'OCR.BACK.MODAL_HELP.TIP_4' | translate }}</span>
                            </div>
                        </div>
                    </tec-tile>
                </tec-tile>
            }
        }

        <!-- HANDSETLANDSCAPE -->
        @if (handsetLandscape && !pageWarning.show) {
            <app-handset-landscape-tile />
        }
    }
</ng-template>

<ng-template #fullActions>
    <!-- SIN PERMISOS -->
    @if (!permissionsCamera) {
        <tec-button type="secondary" [size]="'lg'" (clickEvent)="isVisibleChangeDevice = true">
            {{ 'GENERAL.BUTTON.OTHER_DEVICE' | translate }}
        </tec-button>
        <tec-button [size]="'lg'" (clickEvent)="checkPermissions()">
            {{ 'GENERAL.BUTTON.PERMISSIONS_ACTIVATED' | translate }}
        </tec-button>
    }

    <!-- CON PERMISOS -->
    @if (permissionsCamera) {
        <!-- TUTORIAL -->
        @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
            <tec-button
                [label]="'GENERAL.BUTTON.IM_READY' | translate"
                [type]="'default'"
                [size]="'lg'"
                (clickEvent)="finishTutorial()"
            ></tec-button>
        }

        @if (!operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
            @if (!manualLifeCheckConf?.general?.photo) {
                <tec-button-icon
                    [type]="'circle'"
                    [icon]="'icon-camera'"
                    [size]="'lg'"
                    (clickEvent)="takePicture()"
                ></tec-button-icon>
            }
            @if (manualLifeCheckConf?.general?.photo) {
                <tec-button
                    [label]="'GENERAL.BUTTON.REPEAT' | translate"
                    [type]="'secondary'"
                    [size]="'lg'"
                    (clickEvent)="repeatPhoto()"
                ></tec-button>
                <tec-button
                    [label]="'GENERAL.BUTTON.UPLOAD_PHOTO' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="sendResult(true)"
                ></tec-button>
            }
        }

        <!-- HELP -->
        @if (pageWarning.show) {
            @if (pageWarning.type === PAGE_WARNING.HELP) {
                <!-- DESDE tec-nav-help -->
                @if (isHelpByNavHelp) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeDevice()"
                    ></tec-button>
                    <tec-button
                        [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="setPageWarning(null, false)"
                    ></tec-button>
                }
            }
        }
    }
</ng-template>

<app-modal-scan-qr
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
></app-modal-scan-qr>

<app-modal-help-no-camera-permissions
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleHelpNoPermissionsCamera"
    [url]="auth.getQRUrl()"
></app-modal-help-no-camera-permissions>

<app-modal-change-device
    [ngClass]="{ 'pwcs-style-old': operation.config?.iframe, dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleChangeDevice"
    [url]="auth.getQRUrl()"
></app-modal-change-device>
